<template>
  <b-container fluid class="photo-gallery">
    <b-overlay :show="isFetching" rounded="sm" spinner-variant="primary">
      <b-row>
        <b-col>
          <GalleryActions
            :selected-files="selectedFiles"
            @bulk-download="handleBulkDownload"
            @bulk-delete="handleBulkDelete"
          />
        </b-col>
      </b-row>

      <CategoryCard
        v-for="category in photoCategories"
        :key="category.value"
        :title="category.text"
        :category="category.value"
        :items="filteredList(category.value)"
        :selected-files="selectedFiles"
        :patient-id="patient.id"
        @upload="showUploadModal"
        @upload-success="handleUploadSuccess"
        @upload-error="handleUploadError"
        @select="toggleFileSelection"
        @preview="handlePreview"
        @download="handleDownload"
        @delete="handleDelete"
        @sign="openSignTab"
        @radiiView="openRadiiView"
      />
    </b-overlay>

    <Lightbox
      :index="lightBoxIndex"
      :items="lightBoxList"
      :toolbar="[
        'counter',
        'zoom',
        'slide',
        'rotate',
        'gallery',
        'fullscreen',
        'close',
      ]"
      @close="resetLightbox"
    />
    <UploadFilesModal
      :patientId="patient.id"
      ref="uploadFiles"
      @uploadedFiles="pollForUpdates"
    />
    <Loading v-if="isLoading" />
    <Dialog ref="Dialog" />
  </b-container>
</template>

<script>
import GalleryMixin from "@/mixins/GalleryMixin";
import VueLightbox from "vue-lightbox-lite";
import CategoryCard from "./CategoryCard.vue";
import GalleryActions from "./GalleryActions.vue";
import UploadFilesModal from "@/components/modal/UploadFiles.vue";
import Dialog from "@/components/modal/Dialog.vue";
import Loading from "@/components/Loading.vue";
import "vue-lightbox-lite/dist/index.css";
import truncateText from "@/utils/truncateText";
import formatDate from "@/utils/formatDate";

export default {
  name: "PhotoGallery",
  mixins: [GalleryMixin],
  components: {
    Lightbox: VueLightbox,
    CategoryCard,
    GalleryActions,
    UploadFilesModal,
    Dialog,
    Loading,
  },
  props: {
    patient: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      photoCategories: [
        { text: "Intra-Oral", value: "IntraOralPhoto" },
        { text: "Extra-Oral", value: "ExtraOralPhoto" },
        { text: "X-Ray (DICOM compatible)", value: "XRay" },
        { text: "OPD Card", value: "OpdCard" },
      ],
      truncateText,
      formatDate,
    };
  },
};
</script>

<style scoped>
.photo-gallery .row {
  margin-right: -4px;
  margin-left: -4px;
}

.photo-gallery [class*="col-"] {
  padding-right: 4px;
  padding-left: 4px;
}

.img-wrap {
  position: relative;
}

.img-wrap .img-delete-button {
  position: absolute;
  font-size: 1.2em;
  top: -5px;
  right: -3px;
  z-index: 100;
  cursor: pointer;
  display: none;
}

.img-wrap:hover .img-delete-button {
  display: block;
}

.spinner-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  opacity: 0.5;
  transform: translate(-50%, -50%);
}
</style>